<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add State">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input @focus="nameEmpty = false" class="form-control" type="text" v-model="name" />
          <div class="form-group" style="color: red" v-if="nameEmpty">Name is required</div>
        </div>
      </div>
      <div class="text-center"> 
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="save()"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      nameEmpty: false,
      name: "",
    };
  },
  methods: {
    async save() {
      const formdata = new FormData();
      formdata.append("name", this.name);
      await axios
        .post(`${this.$store.getters.baseUrl}/state/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if(this.name == '') {
            this.nameEmpty = true
            return
          }
          if (response.data.status == 'success') {
            console.log(response);
            this.$swal("Success", "State added successfully", "success");
              this.$router.push({name: 'Tables States'});
            this.name = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        })
    },
  },
};
</script>

